(() => {
  const monthlyPlan = '.select-camping-subscription-monthly-plan'
  const yearlyPlan = '.select-camping-subscription-yearly-plan'
  const activeButton = '.camping-subscription-plan-active-button'
  const disabledButton = '.camping-subscription-plan-disabled-button'
  const disabledButtonItself = '.camping-subscription-plan-disabled-button-itself'

  const init = () => {
    $(activeButton).hide();
    $(disabledButtonItself).prop('disabled', true);
    $('body')
      .on('click', { monthlyPlan, yearlyPlan }, showNextButton)
      .on('click', monthlyPlan, showActiveMonthlyPlan)
      .on('click', '.camping-subscription-monthly', showActiveMonthlyPlan)
      .on('click', yearlyPlan, showActiveYearlyPlan)
      .on('click', '.camping-subscription-yearly', showActiveYearlyPlan)
    showNextButton()
  }

  const showNextButton = () => {
    $(activeButton).hide();
    $(disabledButtonItself).prop('disabled', true);
    if ($('.select-camping-subscription-yearly-plan').is(':checked') || $('.select-camping-subscription-monthly-plan').is(':checked')) {
      $(disabledButton).hide();
      $(disabledButtonItself).prop('disabled', false);
      $(activeButton).show();
    }
  }

  const showActiveMonthlyPlan = () => {
    $('.select-camping-subscription-monthly-plan').prop('checked', true)
    $('.camping-subscription-monthly').addClass('active');
    $('.camping-subscription-yearly').removeClass('active');
  }

  const showActiveYearlyPlan = () => {
    $('.select-camping-subscription-yearly-plan').prop('checked', true)
    $('.camping-subscription-yearly').addClass('active');
    $('.camping-subscription-monthly').removeClass('active');
  }
  $(init);
})();

